export enum LoginStep {
    EMAIL = "EMAIL",
    PASSWORD = "PASSWORD",
    MFA_SELECTION = "MFA_SELECTION",
    MFA_PHONE_COLLECTION = "MFA_PHONE_COLLECTION",
    MFA_TOTP_SETUP = "MFA_TOTP_SETUP",
    MFA_SMS_CODE_COLLECTION = "MFA_SMS_CODE_COLLECTION",
    MFA_TOTP_CODE_COLLECTION = "MFA_TOTP_CODE_COLLECTION",
}

export enum MFAType {
    SMS = "SMS",
    TOTP = "TOTP",
}

export const AUTH_CONFIG = {
    cacheTtlMs: 5 * 60 * 1000,
    cacheMaxTries: 10,

    mfaCodeLength: 6,
    mfaCodeSendMaxAttempts: 5,
    mfaCodeSendDelayMS: 60 * 1000,
    rememberedDeviceExpirationDays: 14,

    get mfaSelectionOptions(): {
        value: MFAType
        title: string
        description: string
    }[] {
        return [
            {
                value: MFAType.SMS,
                title: "Use SMS Verification",
                description:
                    "Receive a code via text message to your mobile device",
            },
            {
                value: MFAType.TOTP,
                title: "Use an Authenticator App",
                description:
                    "Get a code from an app like Google Authenticator, Authy, or Duo.",
            },
        ]
    },
}
